import {GET_UI_CONFIG_SUCCESS} from "./centralUIConfigActions";
import accountService from "src/services/accountService";
import authService from "src/services/authService";
import centralUiConfigService from "src/services/centralUiConfigService";

export const LOGIN_REQUEST = "@account/login-request";
export const LOGIN_SUCCESS = "@account/login-success";
export const LOGIN_FAILURE = "@account/login-failure";
export const FORGOT_PASSWORD_REQUEST = "@account/forgot-password-request";
export const FORGOT_PASSWORD_SUCCESS = "@account/forgot-password-success";
export const FORGOT_PASSWORD_FAILURE = "@account/forgot-password-failure";
export const RESET_PASSWORD_REQUEST = "@account/reset-password-request";
export const RESET_PASSWORD_SUCCESS = "@account/reset-password-success";
export const RESET_PASSWORD_FAILURE = "@account/reset-password-failure";
export const SILENT_LOGIN = "@account/silent-login";
export const LOGOUT = "@account/logout";
export const REGISTER = "@account/register";
export const UPDATE_PROFILE_REQUEST = "@account/update-profile-request";
export const UPDATE_PROFILE_SUCCESS = "@account/update-profile-success";
export const UPDATE_PROFILE_FAILURE = "@account/update-profile-failure";

export function login(email, password, fcmToken) {
  return async (dispatch) => {
    try {
      dispatch({type: LOGIN_REQUEST});
      const loginResult = await authService.loginWithEmailAndPassword(
        email,
        password,
        fcmToken
      );
      if (loginResult) {
        const list_ui_config = await centralUiConfigService.getListUserConfig(
          loginResult.permission_ids
        );

        if (list_ui_config) {
          dispatch({
            type: GET_UI_CONFIG_SUCCESS,
            payload: {
              list_ui_config
            }
          });
        }
        const response = await authService.loginInWithToken(loginResult.user_info.id);

        dispatch({
          type: LOGIN_SUCCESS,
          payload: {
            user: response.data
          }
        });
      }
    } catch (error) {
      dispatch({type: LOGIN_FAILURE});
      throw error;
    }
  };
}

export function setUserData(user) {
  return (dispatch) =>
    dispatch({
      type: SILENT_LOGIN,
      payload: {
        user
      }
    });
}

export function logout() {
  return async (dispatch) => {
    authService.logout();

    dispatch({
      type: LOGOUT
    });
  };
}

export function register() {
  return true;
}

export function updateProfile(data) {
  return async (dispatch) => {
    try {
      dispatch({type: UPDATE_PROFILE_REQUEST});
      const response = await accountService.updateAccount(data);
      dispatch({
        type: UPDATE_PROFILE_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: UPDATE_PROFILE_FAILURE});
      throw error;
    }
  };
}

export function forgotPassword(data) {
  return async (dispatch) => {
    try {
      dispatch({type: FORGOT_PASSWORD_REQUEST});
      const response = await accountService.forgotPassword(data);
      dispatch({
        type: FORGOT_PASSWORD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: FORGOT_PASSWORD_FAILURE});
      throw error;
    }
  };
}

export function resetPassword(data) {
  return async (dispatch) => {
    try {
      dispatch({type: RESET_PASSWORD_REQUEST});
      const response = await accountService.resetPassword(data);
      dispatch({
        type: RESET_PASSWORD_SUCCESS,
        payload: {
          response
        }
      });
    } catch (error) {
      dispatch({type: RESET_PASSWORD_FAILURE});
      throw error;
    }
  };
}
